/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Secondary_School_Teaching28Inputs */

const en__field_enum_study_secondary_school_teaching28 = /** @type {(inputs: _Field_Enum_Study_Secondary_School_Teaching28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary School Teaching`)
};

const de__field_enum_study_secondary_school_teaching28 = /** @type {(inputs: _Field_Enum_Study_Secondary_School_Teaching28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Gymnasien`)
};

/**
* | output |
* | --- |
* | "Secondary School Teaching" |
*
* @param {_Field_Enum_Study_Secondary_School_Teaching28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_secondary_school_teaching28 = /** @type {((inputs?: _Field_Enum_Study_Secondary_School_Teaching28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Secondary_School_Teaching28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_secondary_school_teaching28(inputs)
	return de__field_enum_study_secondary_school_teaching28(inputs)
});
export { _field_enum_study_secondary_school_teaching28 as "_field_enum_STUDY_SECONDARY_SCHOOL_TEACHING" }